// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table {\n  margin-bottom: 10px;\n}\n.inout_row {\n  padding-bottom: 18px;\n}\n.cjzh-container {\n  padding-bottom: 35px;\n}\n.cjzh-container .item {\n  margin-bottom: 15px;\n}", ""]);
// Exports
module.exports = exports;
